import { Flex, Group, Image, Paper, Text, Title } from "@mantine/core";
import React from "react";
import { InfoTooltip } from "../../../shared/components/InfoTooltip";
import { getCurrencySymbol } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import Image1 from "../../../shared/images/market-analysis.png";
import useReportStore from "../../../store/useReportStore";

function UserPrice() {
  const { t } = useTranslation();
  const { userMarketPrice } = useReportStore();

  if (
    !userMarketPrice ||
    typeof userMarketPrice.user_market_price !== "number" ||
    !userMarketPrice.currency ||
    !userMarketPrice.reasoning
  ) {
    return null;
  }

  return (
    <Paper withBorder radius="24px" p="32px" my="lg">
      <Group gap={0} align="center" wrap="nowrap">
        <Flex align="center" gap={11} style={{ minWidth: "100%" }}>
          <Image
            src={Image1}
            alt="Market analysis icon"
            width={36}
            height={36}
            fit="contain"
          />

          <Text fz="20px">
            {t("user_value")}
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
            >
              <b>
                {" "}
                {userMarketPrice.user_market_price.toLocaleString("en-US") +
                  getCurrencySymbol(userMarketPrice.currency)}
              </b>
              <InfoTooltip label={userMarketPrice.reasoning} size={20} />
            </span>
          </Text>
        </Flex>
      </Group>
    </Paper>
  );
}

export default UserPrice;
